module.exports = __webpack_public_path__ + "static/media/gold_offer_myway.f74a5838.jpg";